export const GET_UNITS_REQUEST = 'GET_UNITS_REQUEST';
export const GET_UNITS_SUCCESS = 'GET_UNITS_SUCCESS';
export const GET_UNITS_FAILURE = 'GET_UNITS_FAILURE';

// Add Units
export const ADD_UNITS_REQUEST = 'ADD_UNITS_REQUEST';
export const ADD_UNITS_SUCCESS = 'ADD_UNITS_SUCCESS';
export const ADD_UNITS_FAILURE = 'ADD_UNITS_FAILURE';

// Delete Units
export const DELETE_UNITS_REQUEST = 'DELETE_UNITS_REQUEST';
export const DELETE_UNITS_SUCCESS = 'DELETE_UNITS_SUCCESS';
export const DELETE_UNITS_FAILURE = 'DELETE_UNITS_FAILURE';

// Edit Units
export const EDIT_UNITS_REQUEST = 'EDIT_UNITS_REQUEST';
export const EDIT_UNITS_SUCCESS = 'EDIT_UNITS_SUCCESS';
export const EDIT_UNITS_FAILURE = 'EDIT_UNITS_FAILURE';
